import _ from 'lodash';
import { connect } from 'react-redux';
import { search } from '../../modules/logistics/bulkDelivery';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = state => {

	/** @namespace state.lists.bulkDeliveryIds **/
	/** @namespace state.maps.bulkDelivery **/
	/** @namespace state.maps.user **/
	let bulkDeliveries = [];
	if (state.lists.bulkDeliveryIds) {
		bulkDeliveries = _.map(state.lists.bulkDeliveryIds, id => state.maps.bulkDelivery[id]);
	}
	const canMakeUpdates = !!(_.get(state.auth.authUser, ['permissions', 'canMakeUpdates'], false));
	return {
		bulkDeliveries,
		userMap : state.maps.user,
		supplierMap : state.maps.supplier,
		terminalMap : state.maps.terminal,
		carrierMap : state.maps.carrier,
		bulkCustomerMap : state.maps.bulkCustomer,
		canMakeUpdates,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	searchBulkDeliveries : search,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
